"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chance = void 0;
exports.initChanceSeed = initChanceSeed;
const chance_1 = require("chance");
exports.chance = new chance_1.Chance();
function initChanceSeed(seed) {
    if (seed === undefined) {
        exports.chance = new chance_1.Chance();
    }
    else {
        exports.chance = new chance_1.Chance(seed);
    }
}
//# sourceMappingURL=helpers.js.map